module.exports = __webpack_public_path__ + "img/css-3.ab9495a2.png";